import React, { useState } from 'react';
import {useHistory} from 'react-router-dom'
import axios from 'axios'
import { firestore } from '../firebase'

function Verify() {
    let history = useHistory()
    const [params, setParams] = useState({
        transaction_id: '',
        tx_ref: '',
        
    })

    const [transDetails, setTransDetails] = useState({
        trans_status: '',
        trans_data: '',
        message: ''
    })

    const [user, setUser] = useState({
        data: JSON.parse(localStorage.getItem('formData'))
    })

    const urlParams = new URLSearchParams(history.location.search)

    const transaction_id = urlParams.get('transaction_id')
    const tx_ref = urlParams.get('tx_ref')

    console.log(params)

    const {data} = user
    console.log(data)

    const dbUpload = async() => {
        try {
            let docRef = firestore.collection('users').doc(`/${data.firstname}-${data.lastname}`)

            if(docRef) {
                alert("user exists")
            }
            docRef.set({
                data
            }).then(()=> {
                setUser({
                    data:''
                })
                alert("Hurray!!! Your registeration was successful")
                window.location.replace('/')
            }).catch((error)=> alert(`something went wrong, try again ${error}`))
        } catch (error) {
            console.error(error);
        }
    }

    const sumbitDetails = async() => {
        setParams({
            ...params,
            transaction_id,
            tx_ref
        })

        try {
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*"
                }
            }

            let res = await axios.get('https://eti-portal-v1.herokuapp.com/verify', {params:{transaction_id, tx_ref}}, config)
            await res.data
            let transData = JSON.parse(res.data)
            console.log(transData)    

            setTransDetails({
                ...transDetails,
                trans_status: transData.status,
                trans_data: transData.data,
                message: transData.message
            })
            
            if(transDetails.trans_status === 'success'&& transDetails.trans_data !== null ) {
                const {status, processor_response} = transDetails.trans_data
                status==="successful" && processor_response==="Approved"?
               await dbUpload() :
                console.log("error")
            } else {
                alert(transDetails.message)
            }
            
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="p-5 m-5 d-flex justify-content-center align-items-center flex-column" >

            <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <small>click Next to finish Registeration</small>
            <button className="btn btn-primary btn-sm" onClick={sumbitDetails}>Next</button>
        </div>
    );
}

export default Verify;